import { UnitNumberValue } from './index'
import { types, getParentOfType, getChildType, getRoot } from 'mobx-state-tree'
import {
  IGenerateLimitedUnitNumberBase,
  IGenerateLimitedUnitNumberEnum,
  IGenerateLimitedUnitNumberValue,
  IGenerateLimitedUnitNumberParams
} from './types'
import { IProject } from 'src/api/models/Project/types'
import { IRoot } from 'src/api/stores/Root/types'

const generateLimitedUnitNumberBase: IGenerateLimitedUnitNumberBase = ({ dimension, min, max }) =>
  UnitNumberValue.views(self => {
    const ProjectType = getChildType(getRoot<IRoot>(self).projects) as IProject
    return {
      get min() {
        return min
      },
      get max() {
        const dynamicMax = getParentOfType<IProject>(self, ProjectType)?.getTotalLimit({
          currentValue: self.value,
          dimension,
          layer: 'content'
        }).max
        return max ? Math.min(max, dynamicMax) : dynamicMax
      }
    }
  })

/**
 * type Enum ? => select field
 * type Number ? => numberformatconfig => { min >= 0 ? "allowNegativ":false }
 *
 */

export const generateLimitedUnitNumberEnum: IGenerateLimitedUnitNumberEnum = ({
  options,
  value: defaultValue = options[0],
  dimension,
  min = options.sort()[0],
  max = options.sort()[options.length - 1]
}) => {
  return generateLimitedUnitNumberBase({ dimension, min, max })
    .props({
      value: types.optional(
        types.union(...options.map(option => types.literal(option))),
        defaultValue
      )
    })
    .views(self => ({
      get options() {
        return options?.map(option => ({
          value: option,
          displayValue: self.unit === 'mm' ? option : option * 0.0393700787,
          disabled: self.min > option || option > self.max
        }))
      }
    }))
    .actions(self => ({
      update(value: Unpacked<typeof options>, patch: boolean = true) {
        if (value >= self.min && value <= self.max && options.includes(value)) {
          self.value = value
        }
      }
    }))
}

export const generateLimitedUnitNumberValue: IGenerateLimitedUnitNumberValue = ({
  min,
  max,
  dimension
}) => {
  return generateLimitedUnitNumberBase({ dimension, min, max })
    .views(self => ({
      checkValue() {
        return {}
      }
    }))
    .actions(self => ({
      update(value: number, patch: boolean = true) {
        if (value >= self.min && value <= self.max) {
          console.log(self.min, self.max, value)
          self.value = value
        }
      }
    }))
}

export const generateLimitedUnitNumber = ({
  options,
  value,
  ...params
}: IGenerateLimitedUnitNumberParams) => {
  if (options !== undefined) {
    return generateLimitedUnitNumberEnum({ options, value, ...params })
  }
  return generateLimitedUnitNumberValue({ value, ...params })
}
